<script>
	// Props passed to the component
	export let authors = [];

	// Helper function to create Google Scholar URL
	function googleScholarUrl(name) {
		return `http://scholar.google.com/scholar?as_q=&num=10&btnG=Search+Scholar&as_epq=&as_oq=&as_eq=&as_occt=any&as_sauthors=%22${encodeURIComponent(name)}%22&as_publication=&as_ylo=&as_yhi=&as_allsubj=all&hl=en`;
	}

	// Helper function to create Semantic Scholar URL
	function semanticScholarUrl(name) {
		return `https://www.semanticscholar.org/search?author%5B0%5D=${encodeURIComponent(name)}&q=%22${encodeURIComponent(name)}%22&sort=relevance`;
	}
</script>

<div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
	{#each authors as author, index (author.seq)}
		{@const authorName = `${author.first_name}${author.middle_name ? ' ' + author.middle_name : ''} ${author.last_name}`}
		<div class="flex flex-col p-4" id={`author-info-${index + 1}`}>
			<div class="text-lg font-semibold">
				{authorName}
			</div>
			<div class="text-gray-600">{author.affiliation}, {author.country}</div>
			<div class="flex mt-2 space-x-4">
				{#if author.orcid}
					<a href={`https://orcid.org/${author.orcid}`} class="text-blue-500 hover:underline"
						>ORCID</a
					>
				{/if}
				<a href={googleScholarUrl(authorName)} class="text-blue-500 hover:underline"
					>Google Scholar</a
				>
				<a href={semanticScholarUrl(authorName)} class="text-blue-500 hover:underline"
					>Semantic Scholar</a
				>
			</div>
		</div>
	{/each}
</div>
